import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
export function loginKoordinator(dispatch, data, history) {
  Swal.fire({
    title: "Tunggu ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("/webApiBpd/loginKoordinator", data)
    .then(async (respon) => {
      let { fullname, email, koordinator } = respon.data.data.data;
      Swal.close();
      let dataLogin = {
        Role: "BPD",
        Otp: false,
        Kategori: "Konsumtif",
      };
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(dataLogin),
        "your-secret-key"
      ).toString();

      localStorage.setItem("Data", encryptedData);
      localStorage.setItem("token", respon.data.data.token);
      // localStorage.setItem("Role", "BPD");
      // localStorage.setItem("Kategori", "Konsumtif");
      dispatch({
        type: "SET_IDENTITY_KOORDINATOR",
        data: { fullname, email, koordinator },
      });
      history.push("/koor/pengajuanKoordinator");
    })
    .catch((err) => {
      errorHandler(err.response);
    });
}

export function refreshKoordinator(dispatch) {
  Swal.fire({
    title: "Tunggu ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .get("/webApiBpd/refreshLoginKoordinator", {
      headers: { token: localStorage.getItem("token") },
    })
    .then(async (respon) => {
      let { fullname, email, koordinator } = respon.data.data.data;
      // let dataLogin = {
      //   Role: "BPD",
      //   Otp: false,
      //   Kategori: "Konsumtif",
      // };
      // const encryptedData = CryptoJS.AES.encrypt(
      //   JSON.stringify(dataLogin),
      //   "your-secret-key"
      // ).toString();

      // localStorage.setItem("Data", encryptedData);
      // localStorage.setItem("token", respon.data.data.token);
      // localStorage.setItem("Role", "BPD");
      // localStorage.setItem("Kategori", "Konsumtif");

      dispatch({
        type: "SET_IDENTITY_KOORDINATOR",
        data: { fullname, email, koordinator },
      });
      Swal.close();
    })
    .catch(errorHandler);
}
